export default defineNuxtPlugin(() => {
  if (!import.meta.client) return

  // 修复 Arco Design Vue 图片预览拖拽吸附及原生拖拽冲突问题
  const handleGlobalMouse = (e) => {
    if (e._isArcoFix) return

    // 当检测到鼠标已松开（mouseup）或移动时发现没有按键按下（buttons === 0）
    const isReleased = e.type === 'mouseup' || (e.type === 'mousemove' && e.buttons === 0)

    if (isReleased) {
      const movingImg = document.querySelector('.arco-image-preview-img-moving')
      if (movingImg) {
        // 创建并分发模拟事件，强制 Arco 清理内部状态
        const fixEvent = new MouseEvent('mouseup', {
          bubbles: true,
          cancelable: true,
          view: window,
          clientX: e.clientX,
          clientY: e.clientY,
        })
        fixEvent._isArcoFix = true

        // Arco 监听的是 window 的冒泡阶段 mouseup
        window.dispatchEvent(fixEvent)

        // 如果 class 还没消失，手动强制移除样式干扰
        setTimeout(() => {
          const stillMoving = document.querySelector('.arco-image-preview-img-moving')
          if (stillMoving) {
            stillMoving.classList.remove('arco-image-preview-img-moving')
          }
        }, 0)
      }
    }
  }

  // 注册全局监听器以捕获鼠标释放
  window.addEventListener('mousedown', handleGlobalMouse, true)
  window.addEventListener('mouseup', handleGlobalMouse, true)
  window.addEventListener('mousemove', handleGlobalMouse, true)

  // 智能处理原生 dragstart 行为
  window.addEventListener(
    'dragstart',
    (e) => {
      if (e.target && e.target.classList && e.target.classList.contains('arco-image-preview-img')) {
        const transform = e.target.style.transform || ''
        const scaleMatch = transform.match(/scale\(([^)]+)\)/)
        const scale = scaleMatch ? parseFloat(scaleMatch[1]) : 1

        // 如果图片被放大（需要平移），则阻止原生拖拽
        if (scale > 1) {
          e.preventDefault()
          e.stopPropagation()
        } else {
          // 如果图片未放大，允许原生拖拽（如拖拽到新标签页查看）
          // 但需要强制清理 Arco 的 moving 状态，防止吸附 Bug
          const fixEvent = new MouseEvent('mouseup', {
            bubbles: true,
            cancelable: true,
            view: window,
            clientX: e.clientX,
            clientY: e.clientY,
          })
          fixEvent._isArcoFix = true
          window.dispatchEvent(fixEvent)

          setTimeout(() => {
            const stillMoving = document.querySelector('.arco-image-preview-img-moving')
            if (stillMoving) {
              stillMoving.classList.remove('arco-image-preview-img-moving')
            }
          }, 0)
        }
      }
    },
    true
  )
})
